export default __webpack_public_path__ + "static/media/play.aa89a0f9.svg";